module.exports = __webpack_public_path__ + "static/media/child.44d04495.svg";


//////////////////
// WEBPACK FOOTER
// ./src/parent-agreement/views/main-record/images/child.svg
// module id = 1143
// module chunks = 0